import { render } from "./GeneralDynamicParametres.vue?vue&type=template&id=de18973e"
import script from "./GeneralDynamicParametres.vue?vue&type=script&lang=js"
export * from "./GeneralDynamicParametres.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__